import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadMultipleService {
  // Observable string sources
  private allAddedFiles= new BehaviorSubject<any[]>([]);

  // // Observable string streams
  public allAddedFiles$ = this.allAddedFiles.asObservable();

  public setOpenJustificationDialogToggle(d:any[]){
    // this.storageForQnsbn.dueDateEnabled = d;
    this.allAddedFiles.next([...d]);
  }
  public getOpenJustificationDialogToggle():any{
    return this.allAddedFiles.value;
  }
}
